import { useParams } from "react-router-dom";

/**
 * Read the expected URL params for the Athena application.
 */
export function useAppParams(): {
  tenant: string;
  assessmentId: string;
} {
  const params = useParams<"tenant" | "assessmentId">();

  if (!params.tenant || !params.assessmentId) {
    throw new Error("Missing required URL params");
  }

  return {
    tenant: params.tenant,
    assessmentId: params.assessmentId,
  };
}
